var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtitleAlignment = function SvgSubtitleAlignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.789 10.505 5.972 7.688h11.1v-1H6.404l2.385-2.385-.707-.707-3.809 3.808 3.809 3.808zM13.962 11.8l-.707.707 2.6 2.601H4.973v1h10.884l-2.601 2.601.707.708 3.808-3.809z"
  })));
};
export default SvgSubtitleAlignment;